import service from "@/utils/request";
export var getMerchantFrontPageInfo = function getMerchantFrontPageInfo() {
  return service({
    url: '/merchant/getMerchantFrontPageInfo',
    method: 'post'
  });
};